/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import './list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data) {
  const [resturants, setResturants] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setResturants(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>نام</th>
            <th>توضیحات</th>
            <th>تلفن</th>
            <th>ایمیل</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {resturants ? resturants.map(item => (
              <tr key={item._id}>
                <td>{item.name}</td>
                <td>{item.description}</td>
                <td>{item.tell}</td>
                <td>{item.email}</td>
                <td>
                  <button onClick={() => navigate(`/im/resturants/edit/${item._id}`)}>ویرایش</button>
                </td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
